module.exports = __webpack_public_path__ + "img/company.1c2458e8.svg";